export const URL = "https://api.simcagro.com/api/v1"
// export const URL = "https://ecommerceapi-ee8t.onrender.com/api/v1"
export const get_user_data = `${URL}/admin/public/stats`
export const categories_products = `${URL}/categories`
export const userDetail = `${URL}/users`
export const orders = `${URL}/orders`
export const getAllpackages = `${URL}/packages`
export const getDurationOnePackage =`${URL}/packages`
export const getAllProducts = `${URL}/products-availables-souscription`
export const saveSouscription =`${URL}/packages-souscription`
export const getDetailsSouscription = `${URL}/souscriptions`
export const paiementSouscription = `${URL}/souscription-payment`
export const getAllSouscription = `${URL}/souscriptions/user`
export const getProductByRegion = `${URL}/product-region-recense`
export const getAllUml = `${URL}/measurements`
export const getAllPrice = `${URL}/product-market-prices/latest`
export const popularProducts = `${URL}/highlights`
export const getAllCategories = `${URL}/categories`
export const getTrendPrices = `${URL}/product-market-price-stats`
export const getRegions = `${URL}/admin/regions`
export const getDepartements = `${URL}/admin/departements`
export const line_Chart = `${URL}/line-chart`
export const bar_chart = `${URL}/bar-chart`
export const getProductBySubCategorie = `${URL}/all-products/sub-category`
export const createAccount = `${URL}/register-producer`
export const createAccountTransporteur = `${URL}/register-transporter`
export const getAllProductsSave = `${URL}/products`
export const getCategorieActeur = `${URL}/acteurs`
export const getVendeursByUserCat = `${URL}/acteurs`
export const getProductsByVendeur = `${URL}/acteurs`
export const passerCommande = `${URL}/orders`
export const showTransporteurProposition = `${URL}/users/quotations`
export const getOrder = `${URL}/users`
export const showAllOrderQuotaton = `${URL}/ongoing-orders/users`
export const payerTransporteur = `${URL}/proposals`
export const paiementCommande = `${URL}/payments` 

